export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12292.36c3e32e.jpg";